import {
  COMMERCIAL_DEAL_LIST_REQUEST,
  COMMERCIAL_DEAL_LIST_RECEIVED,
  COMMERCIAL_DEAL_LIST_ERROR,
  COMMERCIAL_DEAL_LIST_UNLOAD,
  COMMERCIAL_DEAL_SINGLE_REQUEST,
  COMMERCIAL_DEAL_SINGLE_RECEIVED,
  COMMERCIAL_DEAL_SINGLE_ERROR,
  COMMERCIAL_DEAL_SINGLE_UNLOAD,
} from "./types";

export const commercialDeals = (
  state = {
    commercialDeals: [],
    error: false,
    isFetchingCommercialDeals: false,
    commercialDealsPage: 1,
    commercialDealsTotalPages: null,
    commercialDealsTotalResults: 0,
    commercialDealsPerPageLimit: 15,
    commercialDealsLastPage: null,
  },
  action
) => {
  switch (action.type) {
    case COMMERCIAL_DEAL_LIST_REQUEST:
      return {
        ...state,
        isFetchingCommercialDeals: true,
      };
    case COMMERCIAL_DEAL_LIST_RECEIVED:
      return {
        ...state,
        isFetchingCommercialDeals: false,
        error: false,
        commercialDeals:
          typeof action.data.data !== "undefined"
            ? action.data.data
            : action.data,
        commercialDealsPage: action.data?.meta?.current_page,
        commercialDealsLastPage: action.data?.meta?.last_page,
        commercialDealsTotalPages: action.data?.meta?.last_page,
        commercialDealsTotalResults: action.data?.meta?.total,
        commercialDealsPerPageLimit: 15,
      };
    case COMMERCIAL_DEAL_LIST_ERROR:
      return {
        ...state,
        isFetchingCommercialDeals: false,
        error: true,
        errorData: action.error,
      };
    case COMMERCIAL_DEAL_LIST_UNLOAD:
      return {
        ...state,
        error: false,
        isFetchingCommercialDeals: false,
        commercialDeals: {},
      };
    default:
      return state;
  }
};

export const commercialDeal = (
  state = {
    commercialDeal: [],
    error: false,
    isFetchingCommercialDeal: false,
  },
  action
) => {
  switch (action.type) {
    case COMMERCIAL_DEAL_SINGLE_REQUEST:
      return {
        ...state,
        isFetchingCommercialDeal: true,
      };
    case COMMERCIAL_DEAL_SINGLE_RECEIVED:
      // console.log(action.data);
      return {
        ...state,
        isFetchingCommercialDeal: false,
        error: false,
        commercialDeal: action.data,
      };
    case COMMERCIAL_DEAL_SINGLE_ERROR:
      return {
        ...state,
        isFetchingCommercialDeal: false,
        error: true,
        errorData: action.error,
      };
    case COMMERCIAL_DEAL_SINGLE_UNLOAD:
      return {
        ...state,
        error: false,
        isFetchingCommercialDeal: false,
        commercialDeal: {},
      };
    default:
      return state;
  }
};
